import { kebabCase } from 'lodash';

import { envService } from 'services';

import {
  calendarArrivaj,
  calendarTouloisirs,
  emptyCartArrivaj,
  emptyCartTouloisirs,
  logoArrivaj,
  logoDarkArrivaj,
  logoDarkTouloisirs,
  logoTouloisirs
} from 'assets/img';

export const appService = {
  brand: () => {
    if (appService.isTouloisirs()) {
      return 'Touloisirs';
    } else if (appService.isArrivaj()) {
      return 'Arrivaj';
    } else {
      return '';
    }
  },
  getBusinessNames: () => {
    if (appService.isTouloisirs()) {
      return [
        // { 'subDomainName': 'businessName' }
        { 'la-poste': 'La Poste' },
        { orange: 'Orange' },
        { touloisirs: 'Touloisirs' }
      ];
    } else if (appService.isArrivaj()) {
      return [
        // { 'subDomainName': 'businessName' }
        ...(envService.isRunningInDev() || envService.isRunningInStaging() ? [{ touloisirs: 'Touloisirs' }] : [])
      ];
    } else {
      return [];
    }
  },
  isTouloisirs: () => {
    if (envService.isRunningInDev()) {
      return window.location.host === 'dev.touloisirs.fr';
    } else if (envService.isRunningInTest()) {
      return window.location.host === 'dev.touloisirs.fr:5100';
    } else if (envService.isRunningInStaging()) {
      return window.location.host === 'preprod.touloisirs.fr';
    } else if (envService.isRunningInProd()) {
      return window.location.host === 'www.touloisirs.fr';
    } else {
      return false;
    }
  },
  isArrivaj: () => {
    if (envService.isRunningInDev()) {
      return window.location.host.includes('dev-') && window.location.host.includes('arrivaj.fr');
    } else if (envService.isRunningInTest()) {
      return window.location.host.endsWith('.dev-arrivaj.fr:5100');
    } else if (envService.isRunningInStaging() || envService.isRunningInProd()) {
      return window.location.host.endsWith('.arrivaj.fr');
    } else {
      return false;
    }
  },
  isRedirection: () => {
    return window.location.host.includes('redirect');
  },
  getCSE: () => {
    const hostname = window.location.hostname;
    const hostnameParts = hostname.split('.');

    if (hostnameParts.length > 2 && hostnameParts.slice(-2).join('.') === 'arrivaj.fr') {
      let subdomain = hostnameParts.at(0).replace(/(dev|preprod)-/, '');

      return kebabCase(subdomain);
    }

    return null;
  },
  getMiddlewareBaseUrl: () => {
    let subdomain = '';
    let domain = window.location.host.split('.').slice(-2).join('.');

    if (envService.isRunningInDev() || envService.isRunningInTest()) {
      subdomain = 'dev-middleware';
    } else if (envService.isRunningInStaging()) {
      subdomain = 'preprod-middleware';
    } else if (envService.isRunningInProd()) {
      subdomain = 'middleware';
    } else {
      throw new Error('Unknown environment');
    }

    return `https://${subdomain}.${domain}`;
  },
  getStrapiBaseUrl: () => {
    let subdomain = '';
    let domain = window.location.host.split('.').slice(-2).join('.');

    if (envService.isRunningInDev() || envService.isRunningInTest()) {
      subdomain = 'dev-admin';
    } else if (envService.isRunningInStaging()) {
      subdomain = 'preprod-knopfler';
    } else if (envService.isRunningInProd()) {
      subdomain = 'knopfler';
    } else {
      throw new Error('Unknown environment');
    }

    return `https://${subdomain}.${domain}`;
  },
  getStrapiServiceName: () => {
    if (appService.isTouloisirs()) {
      return 'strapi_touloisirs';
    } else if (appService.isArrivaj()) {
      return 'strapi_arrivaj';
    } else {
      return null;
    }
  },
  loadBrandImage: (imageType) => {
    switch (imageType) {
      case 'emptyResults':
        return appService.isTouloisirs() ? calendarTouloisirs : calendarArrivaj;
      case 'emptyCart':
        return appService.isTouloisirs() ? emptyCartTouloisirs : emptyCartArrivaj;
      case 'logoDark':
        return appService.isTouloisirs() ? logoDarkTouloisirs : logoDarkArrivaj;
      case 'logo':
        return appService.isTouloisirs() ? logoTouloisirs : logoArrivaj;
      default:
        return null;
    }
  },
  getGtmId: () => {
    return appService.isTouloisirs() ? 'GTM-P5TRPX9Q' : 'GTM-WKZNZCBX';
  },
  getAssistanceUrl: () => {
    if (appService.isTouloisirs()) {
      return 'https://assistance.touloisirs.fr/hc/fr';
    } else {
      return 'https://assistance.arrivaj.fr';
    }
  }
};
